import React, { useEffect, useState } from 'react'
import { v3_plan_approval_comment_replies, v3_plan_approval_comment_reply } from '../../../actions/v3/planApproval'
import moment from 'moment'

const Reply = ({ commentId, planId, revisionId }) => {

    const [message, setMessage] = useState('')
    const [data, setData] = useState(null)
    const onAddReply = () => {
        if (message) {
            v3_plan_approval_comment_reply({ planId, commentId, message, revisionId }).then((res) => {
                if (res.status) {
                    setMessage('')
                    v3_plan_approval_comment_replies(planId, commentId).then((res) => {
                        if (res.status) {
                            setData(res.result)
                        }
                    })
                }
            })
        }
    }

    useEffect(() => {
        if (commentId) {
            v3_plan_approval_comment_replies(planId, commentId).then((res) => {
                if (res.status) {
                    setData(res.result)
                }
            })
        }
        else {
            setData(null)
        }
    }, [commentId])



    return (
        <div className="activity-items">
            {data?.replies?.map((item, index) => {
                const initials = item.CREATED_BY_NAME
                    ?.split(' ')
                    .map(word => word.charAt(0).toUpperCase())
                    .join('');

                const isMine = item.isMine;

                return (
                    <div
                        key={index}
                        className={`activity-item-wrap d-flex mb-3 ${isMine ? 'justify-content-end' : 'justify-content-start'}`}
                    >
                        <div className={`activity-item ${isMine ? 'mine-message' : 'other-message'}`}>
                            <div className="activity-item-meta">
                                <div className="activity-user mb-1">{initials}</div>
                                <p className="activity-summary mb-1">
                                    <strong>{item.CREATED_BY_NAME}:</strong> {item.MESSAGE}
                                </p>
                                <p className="activity-timestamp text-muted mb-0">
                                    {moment(item.CREATED_ON).format('MMM DD, YYYY [at] hh:mm A')}
                                </p>
                            </div>
                        </div>
                    </div>
                );
            })}

            <div className="activity-item">
                <div className="activity-item-meta">
                    <div className="activity-summary">
                        <div className="input-group">
                            <input
                                className="form-control"
                                type="text"
                                value={message}
                                onChange={(e) => {
                                    setMessage(e.target.value)
                                }}
                                placeholder="Type your message"
                            />
                            <span className="input-group-text" onClick={() => {
                                onAddReply()
                            }}>
                                <i className="fas fa-paper-plane" />
                            </span>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    )
}

export default Reply